import { Outlet } from "react-router-dom";
import { OndcContextProvider } from "./OndcContext";

export const OndcRoutesWrapper = () => {
  return (
    <OndcContextProvider>
      <Outlet />
    </OndcContextProvider>
  );
};
